import React from "react";
import Skeleton from "react-loading-skeleton";

import * as Styled from "./mobile.style";

/**
 * Loading state for the app preview.
 *
 * This used to draw a 200px circle and a stack of full-width bars — a shape the
 * preview never takes — so the skeleton bore no relation to what replaced it.
 * It mirrors the real screen instead: hero, title block, chip row, section.
 *
 * The base colours are set here because react-loading-skeleton defaults to a
 * light-grey shimmer, which is right on this light phone surface but wrong for
 * the dark dashboard the component sits in.
 */
const base = { baseColor: "#E2E6E9", highlightColor: "#F1F4F6" };

export const MobileLoader = () => (
  <Styled.Phone>
    <Styled.Header>
      <Skeleton circle width={38} height={38} {...base} />
      <Styled.HeaderTitle>
        <Skeleton width={64} height={14} {...base} />
      </Styled.HeaderTitle>
      <Styled.HeaderSpacer />
    </Styled.Header>

    <Styled.Scroll>
      <Skeleton height={220} borderRadius={20} {...base} />

      <Styled.TitleRow>
        <Styled.TitleBlock>
          <Skeleton height={20} width="70%" {...base} />
          <Skeleton
            height={13}
            width="45%"
            style={{ marginTop: 6 }}
            {...base}
          />
          <Skeleton
            height={12}
            width="60%"
            style={{ marginTop: 6 }}
            {...base}
          />
        </Styled.TitleBlock>
        <Skeleton width={48} height={48} borderRadius={12} {...base} />
      </Styled.TitleRow>

      <Styled.ChipRow>
        <Skeleton width={96} height={31} borderRadius={100} {...base} />
        <Skeleton width={78} height={31} borderRadius={100} {...base} />
      </Styled.ChipRow>

      <Styled.Section>
        <Skeleton height={15} width={92} {...base} />
        <Skeleton
          height={13}
          count={2}
          style={{ marginTop: 8 }}
          {...base}
        />
      </Styled.Section>
    </Styled.Scroll>

    <Styled.Cta>
      <Skeleton width={72} height={15} {...base} />
    </Styled.Cta>
  </Styled.Phone>
);

export default MobileLoader;
